<template>
    <el-button type="danger" plain size="mini" @click="onSubmit" title="Delete">
        Delete
    </el-button>
</template>

<script>
export default {
    props: {
        featureId: {
            type: String,
        },
    },

    methods: {
        async onSubmit() {
            try {
                await this.$confirm('The feature will be permanently removed from this product.', 'Confirm Delete', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
            } catch(err) {
                return false
            }

            try {
                var { data } = await this.$http.delete(`/product-features/${ this.featureId }`)
            } catch(err) {
                this.$message.error(err.response.data.message)

                return false
            }

            this.$emit('delete')
            this.$message.success(data.message)
        },
    },
}
</script>
